import axios from 'axios';

// En production, l'interface et l'API sont servies par le même serveur : une
// adresse relative fonctionne alors quel que soit l'hébergement (Azure, serveur
// interne, adresse IP...) sans aucune reconfiguration.
// En développement, l'interface tourne sur le port 3000 et l'API sur le 5000 :
// on utilise alors l'adresse complète définie dans fronted/.env.
const API_URL =
  process.env.NODE_ENV === 'production'
    ? '/api'
    : process.env.REACT_APP_API_URL || 'http://localhost:5000/api';

const api = axios.create({
  baseURL: API_URL,
});

// Chaque requête transporte le jeton de la session. Le serveur peut ainsi
// identifier l'utilisateur et vérifier ses droits — indispensable pour les
// actions réservées (réinitialisation d'un mot de passe, par exemple).
api.interceptors.request.use((config) => {
  const token = sessionStorage.getItem('token');
  if (token) {
    config.headers = config.headers || {};
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

export default api;
